import { render } from "./TableComponent.vue?vue&type=template&id=02bb217a&scoped=true"
import script from "./TableComponent.vue?vue&type=script&lang=js"
export * from "./TableComponent.vue?vue&type=script&lang=js"

import "./TableComponent.vue?vue&type=style&index=0&id=02bb217a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02bb217a"]])

export default __exports__